<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import appConfig from "@/app.config";
    
    export default {
        page: {
            title: "Doctor TV",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Doctor TV",
                items: [
                {
                    text: "Doctor TV",
                    active: true,
                },                   
                ],

                modal_title: "Add TV",
                button_title: "Save",

                doctorTv: {
                    id: "",
                    name: "",
                    username: "",
                    password: "",
                },

                doctor_tv: [],
                doctor: {},
                tv_status: {
                    id: "",
                    status: "",
                },
                listing_length: 10,
                keyword: '',
                status: '',
                from: null,
                to: null,
                total: null,
                pagination: {},
                token: "",
                errors: {},
                activate: false,
                deactivate: false,

                change_password: {
                    password: '',
                    password_confirmation: '',
                },
                
                active_page_url: null,
                
                loading: false,
            };
        },
        mounted() {

        },

        created() {
            this.fetchDoctorTv();
        },

        methods: {

            fetchDoctorTv(page_url = null) 
            {
                this.getToken();
                let url = "api/admin/viewDoctorTv?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status + "&doctor_id=" + this.$route.params.id;

                page_url = page_url || url;

                if(localStorage.back_url) {
                    page_url = localStorage.back_url;  
                    localStorage.removeItem('back_url');
                }    

                this.active_page_url = page_url;
                this.loading = true;
                
                this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.doctor_tv = responseData.doctor_tv.data;
                    console.log(this.doctor_tv);
                    this.doctor = responseData.doctor;
                    
                    this.pagination = responseData.doctor_tv.links;
                    this.from = responseData.doctor_tv.from;
                    this.to = responseData.doctor_tv.to;
                    this.total = responseData.doctor_tv.total;
                
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                            console.log(error.response.status);
                            } else {
                            this.$swal("", error.response.data.message, "error");
                            }                        
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }, 

            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

            activateTv(tv) {
                this.activate = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to activate this TV?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.activate = value
                    if(this.activate){
                    this.tv_status.id = tv.id;
                    this.tv_status.status = 1;
                    this.updateTvStatus();
                }
                })
                .catch(err => {
                    console.log(err);
                })
            },

            deactivateTv(tv) {
                this.deactivate = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to block this TV?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.deactivate = value
                    if(this.deactivate){
                    this.tv_status.id = tv.id;
                    this.tv_status.status = 2;
                    this.updateTvStatus();
                }
                })
                .catch(err => {
                    console.log(err);
                })
            },

            updateTvStatus() {
                
                this.getToken();
                const config = {
                headers: {
                    "Content-type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

        
                let url = "api/admin/updateDoctorTVStatus?tv_id=" + this.tv_status.id + "&status=" + this.tv_status.status;
                this.$axios
                .get(url, config)
                .then((response) => {                  
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchDoctorTv(this.active_page_url);
                })
                .catch((error) => {                
                    if (error.response) {
                        if (error.response.data.message) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                });
            },

            showModal(modal) {
                this.$refs[modal].show();
            },

            hideModal(modal) {
                this.$refs[modal].hide();
            },

            viewContent(content) {
                this.content = content.content;
                this.showModal("content-modal");
            },

            editTv(tv) {      
                this.modal_title = "Edit TV";
                this.button_title = "Update";
                this.doctorTv.id = tv.id;
                this.doctorTv.name = tv.name;
                this.doctorTv.username = tv.username;
                this.edit = true;
                this.showModal("tv-modal");
            },

            clearForm() {          
                this.modal_title = "Add Tv";
                this.button_title = "Add";
                this.doctorTv.id = "";
                this.doctorTv.name = "";
                this.doctorTv.username = "";
                this.doctorTv.password = "";
                this.edit = false;

                this.change_password.id = "";
                this.change_password.password = "";
                this.change_password.password_confirmation = "";

                this.errors = {};
                this.clinics = [];
            },

            addtv() {
                this.getToken();           
                
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url;
                let formData = new FormData();

                if(!this.edit) {
                    url = "api/admin/addDoctorTv";
                    this.active_page_url = null;
                    formData.append("doctor_id", this.$route.params.id);
                    formData.append("password", this.doctorTv.password); 

                } else {
                    url = "api/admin/updateDoctorTv";
                    formData.append("tv_id", this.doctorTv.id); 
                }         

                formData.append("name", this.doctorTv.name); 
                formData.append("username", this.doctorTv.username); 
            
                this.loading = true;
                
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('tv-modal');
                    this.fetchDoctorTv(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            },

            changePassword(tv) {      
                this.change_password.id = tv.id;
                this.edit = true;
                this.showModal("password-modal");
            },

            updatePassword() {
                this.getToken();           
                
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url = "api/admin/doctorTvChangePassword";
                this.active_page_url = null;
                let formData = new FormData();
                formData.append("tv_id", this.change_password.id); 
                formData.append("password", this.change_password.password); 
                formData.append("password_confirmation", this.change_password.password_confirmation); 
                
                this.loading = true;
            
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('password-modal');
                    this.fetchDoctorTv(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }, 
        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                <div class="card-body">
                    <!-- <h4 class="card-title"></h4>
                    <p class="card-title-desc"></p> -->

                    <div class="row mb-2">
                        <div class="col-12">
                            <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        </div>
                    </div>
                    <!----- top button area starts---->
                    <div class="row mb-3">
                        <div class="col-12">                        
                            <b-button v-b-modal.tv-modal variant="primary" class="float-end">Add TV</b-button>
                        </div>
                    </div>
                    <!----- top button area ends---->

                    <!----- Listing length and search starts ----->
                    <div class="row mb-3">
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-length" >
                            <label
                                >Show
                                <select class="form-control" v-model="listing_length" @change="fetchDoctorTv()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                </select>
                                entries
                            </label>
                            </div>                        
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-filter">
                            <label>
                                <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchDoctorTv()"/>
                            </label>
                            </div>                     
                            <div class="listing-filter me-2">
                            <label>
                                <select class="form-control" v-model="status" @change="fetchDoctorTv()">
                                    <option value="">All</option>
                                    <option value="1">Active</option>
                                    <option value="2">Blocked</option>
                                </select>
                            </label>
                            </div>   
                        </div>
                    </div>
                    <!----- Listing length and search ends ----->

                    <!---- listing table starts -------->
                    <div class="table-responsive">
                        <table class="table table-bordered mb-0">

                            <thead class="table-light">
                            <tr>
                                    <th>Sl No</th>  
                                    <th>Name</th>  
                                    <th>Username</th>  
                                    <th>Status</th> 
                                    <th>Created on</th>
                                    <th>Options</th>
                            </tr>
                            </thead>

                            <tbody v-if="Boolean(doctor_tv.length)">
                                <tr v-for="(tv, index) in doctor_tv" :key="tv.id">
                                    <td>{{from + index}}</td>
                                    <td>{{tv.name}}</td>
                                    <td>{{tv.username}}</td>
                                    <td>
                                        <span v-if="tv.status == 1" class="badge rounded-pill bg-success">Active</span>
                                        <span v-if="tv.status == 2" class="badge rounded-pill bg-danger">Blocked</span>
                                    </td>
                                    <td>{{tv.converted_created_at | formatDateTime }}</td>
                                    <td>
                                        
                                        <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editTv(tv)">Edit</b-button>
                                        <b-button v-if="tv.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateTv(tv)">Block</b-button>

                                        <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateTv(tv)">Activate</b-button>
                                        <b-button variant="danger" class="btn-sm mb-2 me-2" @click="changePassword(tv)"><i class='bx bxs-key'></i></b-button>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-else>
                            <tr>
                                <td colspan="6" class="text-center">No doctor tv found</td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <!---- listing table ends -------->

                    <!----pagination starts ---> 
                    <caption v-if="Boolean(doctor_tv.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                    <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                        <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                            <a href="#" class="page-link" @click.prevent="fetchDoctorTv(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status + '&doctor_id=' + $route.params.id )">
                            <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                            <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                            <span v-else>{{page.label}}</span>                          
                            </a>
                        </li>
                    </ul>
                    <!----pagination ends --->     
                    
                    <!----- Add/Edit data modal starts ---->
                    <b-modal ref="tv-modal" id="tv-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                        <b-form  @submit.prevent="addtv()">                        
                            <div class="row"> 
                            
                            <b-col md="12" class="form-group">
                                <label class="control-label">Name <span class="text-danger">*</span></label>
                                <b-form-input v-model="doctorTv.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                                <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>
                            <b-col md="12" class="form-group">
                                <label class="control-label">Username <span class="text-danger">*</span></label>
                                <b-form-input v-model="doctorTv.username" v-bind:class="{ 'is-invalid': Boolean(errors.username) }"></b-form-input>
                                <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>
                            <b-col md="12" class="form-group" v-if="!this.edit">
                                <label class="control-label">Password <span class="text-danger">*</span></label>
                                <b-form-input v-model="doctorTv.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                                <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>

                            <b-col md="12" class="mt-3">
                                <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    {{ loading ? 'Saving...' : button_title }}
                                </b-button>
                                <b-button class="" variant="light" @click="hideModal('tv-modal')" :disabled="loading">Close</b-button>
                            </b-col>
                            </div>                       
                        </b-form>
                    </b-modal>
                    <!----- Add/Edit data modal ends ---->

                    <!----- update password modal starts ---->
                    <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
                        <b-form @submit.prevent="updatePassword()">
                            <b-row>  
                            <b-col lg="12" class="form-group">
                                <label class="control-label">New Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                                <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>  

                            <b-col lg="12" class="form-group">
                                <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                                <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>    
                            
                            <b-col lg="12">
                                <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    {{ loading ? 'Updating...' : 'Update' }}
                                </b-button>
                                <b-button class="" variant="light" @click="hideModal('password-modal')" :disabled="loading">Close</b-button>
                            </b-col>
                            </b-row>
                        </b-form>
                    </b-modal>
                    <!----- update password modal ends ---->

                </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
